import { Text } from '@dixa/lib-shared-habla';

import { useConversationRow } from '../../../utils/useConversationRow';

/** Represents the content of the queue cell in the conversations table. */
export const ConversationsTableQueue = (): JSX.Element => {
  const { conversation } = useConversationRow();

  return (
    <>
      {conversation.queue?.name ?? (
        <Text.Paragraph color="tertiary" as="em">
          Not in a queue
        </Text.Paragraph>
      )}
    </>
  );
};
